import { Stack, Typography } from '@mui/material';
import { FC, ReactElement } from 'react';

type TScreenHeaderProps = {
    title: string;
    desc?: string | ReactElement;
    margin?: number;
    size?: 'small' | 'large';
};

const ScreenHeader: FC<TScreenHeaderProps> = (props) => {
    const { title, desc, margin = 2, size = 'small' } = props;
    return (
        <Stack component={'header'} spacing={1} sx={{ my: margin, textAlign: { lg: 'center' } }}>
            <Typography component={'h1'} variant={size === 'small' ? 'subtitle1' : 'h5'}>
                {title}
            </Typography>
            <Typography component={'p'} variant={'body2'} data-testid="screen-header-desc">
                {desc}
            </Typography>
        </Stack>
    );
};

export default ScreenHeader;
